export default __webpack_public_path__ + "static/media/logo2.b500d360.png";